import { EVALUATION_CATEGORIES } from "../constants";
import {
  COACH_EVALUATION,
  PARENT_EVALUATION,
  STUDENT_EVALUATION,
} from "./constants";

export const getLabel = (category?: EVALUATION_CATEGORIES) => {
  let label = "";

  switch (category) {
    case EVALUATION_CATEGORIES.STUDENT:
      label = STUDENT_EVALUATION;
      break;
    case EVALUATION_CATEGORIES.COACH:
      label = COACH_EVALUATION;
      break;
    case EVALUATION_CATEGORIES.PARENT:
      label = PARENT_EVALUATION;
      break;
    default:
      label = STUDENT_EVALUATION;
  }

  return label;
};



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/survey-link/utils/getLabel.ts